(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-timeline_v3"] && !Shopify.designMode) return;
  try {
    
    const gridMutationCallback = (mutationList) => {

        for (const mutation of mutationList) {
            if (mutation.type === 'attributes' && mutation.attributeName && mutation.attributeName.startsWith("data-")) {
                //console.log(`data- attribute changed on element:`, mutation.target);
                //console.log(`Attribute name: ${mutation.attributeName}`);
                //console.log(`Old value: ${mutation.oldValue}`);
                //console.log(`New value: ${mutation.target.getAttribute(mutation.attributeName)}`);
            }

            if (mutation.attributeName === "data-display-content") {
                const headerInfo = mutation.target.getElementsByClassName("header-info")[0];
                const contentList = mutation.target.getElementsByClassName("product-info");
                if ( !mutation.target.getAttribute("data-select-content")) {
                    for (let i = 0; i < contentList.length; i++) {
                        const content = contentList[i];
                        if (content.id === mutation.target.getAttribute(mutation.attributeName)) {
                            content.parentElement.classList.remove("shy");
                            content.parentElement.classList.add("verbose");
                        }
                        else {
                            content.parentElement.classList.add("shy");
                            content.parentElement.classList.remove("verbose");
                        }               
                    }

                    if (mutation.target.getAttribute(mutation.attributeName) == "") {
                        headerInfo.parentElement.classList.remove("shy");
                        headerInfo.parentElement.classList.add("verbose");
                    }
                    else {
                        headerInfo.parentElement.classList.add("shy");
                        headerInfo.parentElement.classList.remove("verbose");
                    }
                }
                
            }
            if (mutation.attributeName === "data-select-content") {
                const headerInfo = mutation.target.getElementsByClassName("header-info")[0];
                const contentList = mutation.target.getElementsByClassName("product-info");
                
                for (let i = 0; i < contentList.length; i++) {
                    const content = contentList[i];
                    if (content.id === mutation.target.getAttribute(mutation.attributeName)) {
                        content.parentElement.classList.remove("shy");
                        content.parentElement.classList.add("verbose");
                    }
                    else {
                        content.parentElement.classList.add("shy");
                        content.parentElement.classList.remove("verbose");
                    }                
                }

                if (mutation.target.getAttribute(mutation.attributeName) == "") {
                    headerInfo.parentElement.classList.remove("shy");
                    headerInfo.parentElement.classList.add("verbose");
                }
                else {
                    headerInfo.parentElement.classList.add("shy");
                    headerInfo.parentElement.classList.remove("verbose");
                }
                
            }
        }

    };
    document.addEventListener('DOMContentLoaded', (event) => {
        const productGrids = document.getElementsByClassName("product-list-grid");
        const gridObserver = new MutationObserver(gridMutationCallback);
        for (let i = 0; i < productGrids.length; i++) {
            const grid = productGrids[i];
            const observerOps = {
                attributes: true, // Observe attribute changes
                attributeOldValue: true, // Get the old value of the attribute
                subtree: false, // Don't observe changes in child nodes (set to true if needed)
            };
            const blockID = grid.id;

            console.log("[Look Book JS] Found Collection: " + blockID);

            const contentBlock = document.querySelector(`div[data-id-content="${blockID}"]`);
            if (contentBlock){
                gridObserver.observe(contentBlock,observerOps);
                const productCardLinks = grid.getElementsByClassName("product-card");
                for (let i = 0; i < productCardLinks.length; i++) {
                    const card = productCardLinks[i];
                    const handle = card.getAttribute("handle");
                    console.log("[Look Book JS] Found Product in Collection: " + handle);
                    card.addEventListener( "mouseenter", () => {
                        contentBlock.setAttribute('data-display-content', handle);
                    });
                    card.addEventListener( "mouseleave", () => {
                        contentBlock.setAttribute('data-display-content', "");
                    });
                    // card.querySelector('button').addEventListener("click", () => {
                    //     contentBlock.setAttribute('data-display-content', handle);
                    //     contentBlock.setAttribute('data-select-content', handle);
                    // });
                }
            }
        }
    });


  } catch(e) { console.error(e); }
})();
})();
